'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaitlistFormValidator = undefined;

var _validators = require('validators');

var WaitlistFormValidator = exports.WaitlistFormValidator = (0, _validators.composeValidators)((0, _validators.validateFields)(_validators.requiredValidator, ['email']), (0, _validators.validateFields)(_validators.emailValidator, ['email']));